import { Typography } from '@jouzen/ecom-components/v3/Typography';
import { useTranslations } from 'next-intl';
import type { MessageKey } from 'types/LocaleMessageKey';

import Image from '@/app/components/Image';

export interface CardQuoteProps {
  readonly affiliation: string;
  readonly avatarUrl: string;
  readonly name: string;
  readonly quote: MessageKey;
}

const CardQuote = ({ affiliation, avatarUrl, name, quote }: CardQuoteProps) => {
  const t = useTranslations();

  return (
    <div className="p-12">
      <Typography Element="q" className="mb-8 text-lg">
        {t(quote)}
      </Typography>
      <div className="mt-8 flex items-center">
        <Image
          src={avatarUrl}
          alt={`Avatar for ${name}`}
          className="mr-4 rounded-full"
          width={40}
          height={40}
        />
        <div>
          <Typography variant="body-small" weight="bold">
            {name}
          </Typography>
          <Typography variant="eyebrow-small" weight="light">
            {affiliation}
          </Typography>
        </div>
      </div>
    </div>
  );
};

export default CardQuote;
